import Container from '@mui/material/Container';
import ErrorPanel from 'components/ErrorPanel/ErrorPanel';
import { useTranslation } from 'react-i18next';

import styles from '../styles/Generic.module.scss';

export default function NotFoundTemplate() {
  const { t } = useTranslation();

  return (
    <Container
      data-testid="NotFoundTemplate-test-id"
      className={styles.root}
    >
      <ErrorPanel
        title={t('errors.notFound.title')}
        description={t('errors.notFound.description')}
      />
    </Container>
  );
}
